import api from './client'

export const presupuestosApi = {
  listar: (params = {}) => api.get('/presupuestos', { params }),
  obtener: (id) => api.get(`/presupuestos/${id}`),
  crear: (data) => api.post('/presupuestos', data),
  // Percepciones automáticas EN VIVO para el form (la regla vive en el backend)
  percepcionesPreview: (payload) => api.post('/presupuestos/percepciones-preview', payload),
  // Pegar el texto de un pedido → la IA arma los renglones (artículo real o null + cantidad)
  interpretarPedido: (texto, clienteId) => api.post('/presupuestos/interpretar-pedido', { texto, cliente_id: clienteId || null }),
  actualizar: (id, data) => api.put(`/presupuestos/${id}`, data),
  eliminar: (id) => api.delete(`/presupuestos/${id}`),

  enviar: (id) => api.post(`/presupuestos/${id}/enviar`),
  aceptar: (id, gruposElegidos = []) => api.post(`/presupuestos/${id}/aceptar`, { grupos_elegidos: gruposElegidos }),
  // cierre: 'nueva_version' (devuelve la v siguiente) | 'perdido' | null
  rechazar: (id, motivo, cierre = null) => api.post(`/presupuestos/${id}/rechazar`, { motivo, cierre }),
  perder: (id, motivo = null) => api.post(`/presupuestos/${id}/perder`, { motivo }),
  // Paso 5 del recorrido (solo supervisor / administrador)
  devolver: (id, motivo) => api.post(`/presupuestos/${id}/devolver`, { motivo }),
  // Presupuestos vivos de un cliente (aviso del form)
  enCurso: (clienteId) => api.get('/presupuestos/en-curso', { params: { cliente_id: clienteId } }),
  nuevaVersion: (id) => api.post(`/presupuestos/${id}/nueva-version`),
  convertir: (id) => api.post(`/presupuestos/${id}/convertir`),
  cambiarCliente: (id, clienteId) => api.put(`/presupuestos/${id}/cliente`, { cliente_id: clienteId }),
  enviarMail: (id, email, mensaje) => api.post(`/presupuestos/${id}/enviar-mail`, { email, mensaje }),
  compartirWa: (id) => api.post(`/presupuestos/${id}/compartir-wa`),

  // Imágenes de referencia de la versión (sug #95): solo en borrador.
  subirImagenes: (id, archivos) => {
    const fd = new FormData()
    archivos.forEach(f => fd.append('imagenes[]', f))
    return api.post(`/presupuestos/${id}/imagenes`, fd)
  },
  quitarImagen: (id, imagenId) => api.delete(`/presupuestos/${id}/imagenes/${imagenId}`),
  // El archivo vive en disco privado: se pide con el token y se muestra como blob.
  imagenBlob: (url) => api.get(url, { responseType: 'blob' }).then(r => r.data),

  // Descargas autenticadas (blob → save)
  descargar: async (id, formato, numero) => {
    const { data } = await api.get(`/presupuestos/${id}/${formato}`, { responseType: 'blob' })
    const url = URL.createObjectURL(data)
    const a = document.createElement('a')
    a.href = url
    a.download = `presupuesto_${numero}.${formato === 'pdf' ? 'pdf' : formato}`
    a.click()
    URL.revokeObjectURL(url)
  },
}
